import styles from './../styles/layout.module.scss';
import Header from './header';
import Footer from './footer';
import tel from './../img/tel.svg';
import mail from './../img/mail.svg';
import whats from './../img/whatsapp.svg';
import favicon from '../img/favicon.png';
import React from 'react';
import { Link } from 'gatsby';
import { Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet';
const Layout = (props) => {
  if (typeof window !== 'undefined') {
    require('smooth-scroll')('a[href*="#"]');
  }
  return (
    <div className={styles.contenedorHeader}>
      <Helmet link={[{ rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }]}>
        <meta charSet="utf-8" />
        <title>Balvanera | Palermo SOHO</title>
      </Helmet>
      <Header />
      <div> {props.children} </div>
      <div className={styles.containerFlotante + ' d-none d-md-block'}>
        <Link className="px-5" to="/#contacto">
          CONTÁCTANOS
        </Link>
      </div>
      <div className={styles.containerFlotante + ' px-5 py-3 d-md-none'}>
        <Row className="mx-0">
          <Col className="px-0 py-1 justify-content-center">
            <Link target="_blank" to="/#contacto">
              <img src={mail} className={'lazyload'} alt="Mail icon" />
            </Link>
          </Col>
          <Col className="px-0 py-1 justify-content-center">
            <a rel="noopener noreferrer" target="_blank" href="tel:+442251661">
              <img src={tel} className="lazyload" alt="Tel icon" />
            </a>
          </Col>
          <Col className="px-0 py-1 justify-content-center">
            <a rel="noopener noreferrer" target="_blank" href="https://wa.me/5214421862817">
              <img src={whats} className={styles.whatsappIcon + ' lazyload'} alt="Whatsapp icon" />
            </a>
          </Col>
        </Row>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
